import React, { Suspense } from "react";
import CircularProgress from "@vapor/react-material/CircularProgress";

export const Loader = ({ children }) => {
    return (
        <Suspense
            fallback={
                <CircularProgress
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }}
                />
            }
        >
            {children}
        </Suspense>
    );
};
